<rt-icon-button
  #tableConfigDropdownTrigger="rtOverlayOrigin"
  (click)="toggleTableConfigDropdown()"
  [pressed]="dropdownOpened"
  [disabled]="disabled()"
  variant="tertiary"
  iconName="table-edit"
  shape="square"
  rt-overlay-origin
>
  <rt-icon name="table-edit" />
</rt-icon-button>

<ng-template
  #tableConfigDropdown="rtConnectedOverlay"
  rt-connected-overlay
  [hasBackdrop]="true"
  [open]="dropdownOpened"
  [origin]="tableConfigDropdownTrigger"
  (backdropClick)="toggleTableConfigDropdown()"
>
  <rt-dropdown>
    <rt-dropdown-header>
      {{ 'rtu.search.table.adjust_columns' | translate }}
    </rt-dropdown-header>
    <div
      #dataTableOptionsDropdown
      cdkDropList
      (cdkDropListDropped)="onDrop($event)"
      [style.maxHeight]="'220px'"
      class="has-scroll-y drag-boundary"
    >
      @for (column of tableColumns(); track trackByColumnId($index, column)) {
        <rt-dropdown-item
          (click)="toggleColumnVisibility(column); $event.preventDefault()"
          [hasHoverEffect]="hoverEffects !== false"
          cdkDrag
          cdkDropListLockAxis="y"
          cdkDragBoundary=".drag-boundary"
        >
          <rt-checkbox
            prefix
            [style.pointerEvents]="'none'"
            [disabled]="!column.options.removable"
            [checked]="column.visible"
          />
          <div layout layout-align-items-center>
            <div [innerHtml]="column.label"></div>
            @if (column.isNew) {
              <rt-badge
                color="pink-gradient"
                [text]="'app.common.new' | translate"
                margin-left-small-x
              />
            }
          </div>
          <rt-icon
            suffix
            [hasAutoHeight]="true"
            size="small"
            name="drag-vertical"
            class="drag-icon"
          />
        </rt-dropdown-item>
      }
    </div>

    <rt-divider />
    @if (!hideAutoFit()) {
      <rt-dropdown-item (click)="tableAutoFitChange.emit(!tableAutoFit()); $event.preventDefault()">
        <rt-checkbox prefix [style.pointerEvents]="'none'" [checked]="tableAutoFit()" />
        {{
          (tableAutoFit()
            ? 'rtu.search.table.auto_fit_enabled'
            : 'rtu.search.table.auto_fit_disabled'
          ) | translate
        }}
      </rt-dropdown-item>
    }
  </rt-dropdown>
</ng-template>
